import React from "react";
import GlobalStyles from 'styles/GlobalStyles';
import { css } from "styled-components/macro"; //eslint-disable-line
import LoginPage from "pages/Login.js";
import SignUp from "pages/Signup";
import NotFound from "pages/NotFound";
import { AppProvider } from "components/context/AppContext";
import NewPaymentPage from "pages/NewPaymentPage";
import AccountingPage from "pages/AccountingPage";
import DocumentsPage from "pages/DocumentsPage";
import AmenitySelectionPage from "pages/AmenitySelectionPage";
import AdminPaymentsPage from "pages/AdminPaymentsPage"; 
import AdminOwnersPage from "pages/AdminOwnersPage";
import AdminDashboardPage from "pages/AdminDashboardPage";

/*
 * This is the entry point component of this project. You can change the below exported default App component to any of
 * the prebuilt landing page components by uncommenting their import and export lines respectively.
 * See one of the landing page components to better understand how to import and render different components (Always
 * make sure if you are building your own page, the root component should be the AnimationRevealPage component. You can
 * disable the animation by using the disabled prop.
 *
 * The App component below is using React router to render the landing page that you see on the live demo website
 * and the component previews.
 *
 */

/* Use AnimationRevealPage as a wrapper component for your pages if you are building a custom one yourself */

/*
 * Hero section is the top most section on the page. It contains the header as well.
 * So you dont need to import headers
 * separately
 */

import ComponentRenderer from "ComponentRenderer.js";
import MainLandingPage from "MainLandingPage.js";
import ThankYouPage from "ThankYouPage.js";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfServicePage from "./pages/TermsOfService";
import VisitorRegisterPage from "pages/VisitorRegisterPage.js";
import MisVisitas from "pages/VisitorPage.js";
import PricingPage from "./pages/Pricing.js";
import ContactUsPage from "./pages/ContactUs.js";
import ContactUsBizCodePage from "./pages/ContactUsBizCode.js";
import OfficeBizCodePage from "./pages/OfficeBizCode.js";
import FaqsPage from "pages/FaqsPage";
import Announcements from "./pages/Announcements";
import BizCodePage from "pages/BizCodePage";
import { AdminRoute, UserRoute, RoleBasedRoute } from "pages/RoleBasedRoute";
import { ROUTE_PATHS } from "utils/routes";

import VisitorQrPage from "pages/VisitorQrPage";
import InvitationActivationPage from "pages/InvitationActivationPage";
import PaymentPage from "pages/PaymentPage";
import FeaturesPage from "pages/FeaturesPage";
import AmenitiesPage from "pages/AmenitiesPage";
import NotificationSystem from "components/misc/NotificationSystem";
import NewAmenityPage from "pages/NewAmenityPage";
import AdminAmenitiesPage from "pages/AdminAmenitiesPage";
import AdminAccountingPage from "pages/AdminAccountingPage";
import AdminAnnouncementsPage from "pages/AdminAnnouncementsPage";
import AdminCatalogsPage from "pages/AdminCatalogsPage";
import AccessDoorPage from "pages/AccessDoorPage";

export default function App() {
  // If you want to disable the animation just use the disabled `prop` like below on your page's component
  // return <AnimationRevealPage disabled>xxxxxxxxxx</AnimationRevealPage>;
  return (
    <>
      <GlobalStyles />
      <AppProvider>
        <NotificationSystem />
        <Router>
          
            <Routes>
                <Route path="/components/:type/:subtype/:name" element={<ComponentRenderer />} />
                <Route path="/components/:type/:name" element={<ComponentRenderer />} />
                <Route path="/" element={<MainLandingPage />} />
                <Route path={ROUTE_PATHS.INICIOSESION} element={<LoginPage ImageSrc="images/demo/LoginPage.jpeg" />} />
                <Route path="/registro" element={<SignUp ImageSrc="images/demo/SignupPage.jpeg" />} />
                <Route path="/not-found" element={<NotFound ImageSrc="images/demo/NotFound.jpg" />} />
                <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
                <Route path="/terminos-uso" element={<TermsOfServicePage />} />
                <Route path="/suscripcion" element={<PricingPage />} />
                <Route path="/contacto" element={<ContactUsPage />} />
                <Route path="/bizcode-contactus" element={<ContactUsBizCodePage />} />
                <Route path="/bizcode-office" element={<OfficeBizCodePage />} />
                <Route path="/bizcode-faqs" element={<FaqsPage />} />
                <Route path="/bizcode-home" element={<BizCodePage />} />
                <Route path={ROUTE_PATHS.FEATURES} element={<FeaturesPage />} />
                <Route path={ROUTE_PATHS.VISITORQR} element={<VisitorQrPage />} />
                <Route path={ROUTE_PATHS.INVITATION_ACTIVATION} element={<InvitationActivationPage />} />
                <Route path={ROUTE_PATHS.VISITREGISTER} element={<UserRoute><VisitorRegisterPage /></UserRoute>} />
                <Route path={ROUTE_PATHS.VISIT} element={<UserRoute><MisVisitas /></UserRoute>} />
                <Route path={ROUTE_PATHS.PAYMENTS} element={<UserRoute><PaymentPage /></UserRoute>} />
                <Route path={ROUTE_PATHS.ANNOUNCEMENTS} element={<RoleBasedRoute allowedRoles={['user', 'admin']}><Announcements /></RoleBasedRoute>} />
                <Route path={ROUTE_PATHS.NEWPAYMENT} element={<UserRoute><NewPaymentPage /></UserRoute>} />
                <Route path={ROUTE_PATHS.ACCOUNTING} element={<UserRoute><AccountingPage /></UserRoute>} />
                <Route path={ROUTE_PATHS.AMENITIES} element={<UserRoute><AmenitiesPage /></UserRoute>} />
                <Route path={ROUTE_PATHS.NEWAMENITYPAGE} element={<UserRoute><NewAmenityPage /></UserRoute>} />
                <Route path={ROUTE_PATHS.DOCUMENTS} element={<RoleBasedRoute allowedRoles={['user', 'admin']}><DocumentsPage /></RoleBasedRoute>} />
                <Route path={ROUTE_PATHS.AMENITYSELECTION} element={<UserRoute><AmenitySelectionPage /></UserRoute>} />
                <Route path={ROUTE_PATHS.ADMINPAYMENTPAGE} element={<AdminRoute><AdminPaymentsPage /></AdminRoute>} />
                <Route path={ROUTE_PATHS.ADMINPAYMENTPAGEBYID} element={<AdminRoute><AdminPaymentsPage /></AdminRoute>} />
                <Route path={ROUTE_PATHS.ADMINDASHBOARD} element={<AdminRoute><AdminDashboardPage /></AdminRoute>} />
                <Route path={ROUTE_PATHS.ADMINOWNERSPAGE} element={<AdminRoute><AdminOwnersPage /></AdminRoute>} />
                <Route path={ROUTE_PATHS.ADMINAMENITIESPAGE} element={<AdminRoute><AdminAmenitiesPage /></AdminRoute>} />
                <Route path={ROUTE_PATHS.ADMINACCOUNTINGPAGE} element={<AdminRoute><AdminAccountingPage /></AdminRoute>} />"
                <Route path={ROUTE_PATHS.ADMINANNOUNCEMENTSPAGE} element={<AdminRoute><AdminAnnouncementsPage /></AdminRoute>} />
                <Route path={ROUTE_PATHS.ADMINCATALOGSPAGE} element={<AdminRoute><AdminCatalogsPage /></AdminRoute>} />
                <Route path={ROUTE_PATHS.ACCESSDOORPAGE} element={<AccessDoorPage />} />
                <Route path="*" element={<NotFound />} /> 
              </Routes>
          
        </Router>
      </AppProvider>
    </>
  );
}
